import { useMutation } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import {
  TechFeedbackErrorResponse,
  TechFeedbackParams,
  TechFeedbackResponse,
} from "./techFeedback";

export const useSubmitTechFeedback = () => {
  const { post } = useApi();

  return useMutation<
    TechFeedbackResponse,
    TechFeedbackErrorResponse,
    TechFeedbackParams
  >({
    mutationFn: (params) =>
      post("tech_feedbacks", params).then((res) => res.data),
  });
};
